.list {
  & > dt:first-of-type {
    margin-top: var(--dds-spacing-x1);
  }
  & > dd:last-child {
    margin-bottom: var(--dds-spacing-x1);
  }
  dd + dt {
    margin-top: var(--dds-spacing-x2);
  }
}

.list--default {
  dt {
    color: var(--dds-color-text-body);
    font-weight: 600;
  }
}

.list--subtle {
  dt {
    color: var(--dds-color-text-body-subtle);
  }
}

.list--row {
  &:not(:has(> dt):has(> dd)) {
    flex-direction: row;
  }
}

.list--column {
  &:not(:has(> dt):has(> dd)) {
    flex-direction: column;
  }
}

.desc {
  margin-inline-start: 0;
  align-items: center;
  display: flex;
  gap: var(--dds-spacing-x0-25);
  color: var(--dds-color-text-body);
}

.group {
  margin: var(--dds-spacing-x2);
}
